import React, {useEffect, useState} from 'react';
import {useForm, Controller} from 'react-hook-form';
import classnames from 'classnames';
import {useSelector, useDispatch} from 'react-redux';

import * as S from './UpdateDetailsForm.styles';
import {
  makeGetRequest,
  makePostRequest,
  updateFormFieldsData,
  getFormFieldsDataSelector,
} from '@ibibo/myaccount-reducer';
import UserInputs from './UserInputs';

import {UPDATE_FORMFIELD_DATA_LOGIN} from '../../../../../../../onboarding/src/store/actions/actionTypes';
import {formFieldsSelector} from '../../../../../../../onboarding/src/store/selectors';
const UpdateDetailsForm = ({
  header,
  body,
  data,
  is_closable,
  classes,
  successCallback,
  errorCallback,
  errorMessages,
  closeModal,
  make_initial_api_call = false,
  initial_api_call,
  setModalUpdateDetailsData,
  componentData,
  setErrorMessage,
  modalUpdateDetailsData,
  updateFormFiledsDataOnLogin = false,
  flagForBodyData = false, //Flag added to update the final body data from map or inital body values
}) => {
  const dispatch = useDispatch();

  const formFieldsData = useSelector(getFormFieldsDataSelector);
  const formFieldsDataLogin = useSelector(formFieldsSelector);
  const {heading, subHeading} = header || {};
  const {formFields, submitButton} = body || {};

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (make_initial_api_call) {
      makeInitialApiCall(initial_api_call);
    }
  }, [JSON.stringify(modalUpdateDetailsData), make_initial_api_call]);

  const {
    register,
    handleSubmit,
    formState: {errors},
    reset,
    getValues,
    control,
  } = useForm();

  const onSubmitOnLogin = data => {
    const formDataMap = JSON.parse(JSON.stringify(formFieldsDataLogin));
    for (const i in data) {
      formDataMap[i] = data[i];
    }
    for (const i in modalUpdateDetailsData?.formFields) {
      formDataMap[i] = modalUpdateDetailsData?.formFields[i];
    }
    if (updateFormFiledsDataOnLogin) {
      dispatch({type: UPDATE_FORMFIELD_DATA_LOGIN, payload: formDataMap});
    }
    dispatch(updateFormFieldsData({...formDataMap}));
    if (submitButton) {
      const {
        api: {body, url, type, queryParamsToBeAdded = [], isQueryParamsAdded = false},
      } = submitButton;
      makeApiCall(type, url, isQueryParamsAdded, queryParamsToBeAdded, formDataMap, body);
    }
    return false;
  };
  const onSubmit = data => {
    const formDataMap = JSON.parse(JSON.stringify(formFieldsData));
    for (const i in data) {
      formDataMap[i] = data[i];
    }
    for (const i in modalUpdateDetailsData?.formFields) {
      formDataMap[i] = modalUpdateDetailsData?.formFields[i];
    }

    dispatch(updateFormFieldsData({...formDataMap}));
    if (submitButton) {
      const {
        api: {body, url, type, queryParamsToBeAdded = [], isQueryParamsAdded = false},
      } = submitButton;
      makeApiCall(type, url, isQueryParamsAdded, queryParamsToBeAdded, formDataMap, body);
    }
    return false;
  };

  const successCallbackFunction = resp => {
    successCallback && successCallback(resp);
    setLoader(false);
    reset();
  };

  const errorCallbackFunction = err => {
    errorCallback && errorCallback(err);
    setLoader(false);
    reset();
  };

  const clickHandler = rowData => {
    const formDataMap = updateFormFiledsDataOnLogin
      ? JSON.parse(JSON.stringify(formFieldsDataLogin))
      : JSON.parse(JSON.stringify(formFieldsData));
    for (const i in data) {
      formDataMap[i] = data[i];
    }

    const {
      api: {body, url, type, queryParamsToBeAdded = [], isQueryParamsAdded = false},
    } = rowData;
    makeApiCall(type, url, isQueryParamsAdded, queryParamsToBeAdded, formDataMap, body);
  };

  const makeInitialApiCall = api => {
    const {url, type, body} = api;
    if (type === 'GET') {
      dispatch(makeGetRequest(url, successCallbackFunction, errorCallbackFunction));
    } else {
      dispatch(makePostRequest(url, body, successCallbackFunction, errorCallbackFunction));
    }
  };

  const makeApiCall = (
    type,
    url,
    isQueryParamsAdded = false,
    queryParamsToBeAdded = [],
    objectToCopy = {},
    body = {},
  ) => {
    setLoader(true);
    if (type && type === 'GET') {
      let apiUrl = url;
      if (isQueryParamsAdded) {
        for (let i = 0; i < queryParamsToBeAdded?.length; i++) {
          const obj = queryParamsToBeAdded[i];
          const url = apiUrl.replace(obj?.replacable, objectToCopy[obj?.name]);
          apiUrl = url;
        }
      }
      dispatch(makeGetRequest(apiUrl, successCallbackFunction, errorCallbackFunction));
    } else {
      const bodyToSend = Object.assign({}, body);
      for (const i in bodyToSend) {
        if (flagForBodyData) {
          if (i in objectToCopy) bodyToSend[i] = objectToCopy[i];
          else bodyToSend[i] = body[i];
        }
        if (!bodyToSend[i]) bodyToSend[i] = objectToCopy[i];
      }
      dispatch(makePostRequest(url, bodyToSend, successCallbackFunction, errorCallbackFunction));
    }
  };

  const openModal = row => {
    setErrorMessage && setErrorMessage();
    reset();
    setModalUpdateDetailsData &&
      setModalUpdateDetailsData({
        componentData: componentData,
        modalData:
          componentData[row?.modalDataKeyToSend] || componentData?.data[row?.modalDataKeyToSend],
      });
  };

  return (
    <S.Container>
      <div className={classnames(classes)}>
        {is_closable && (
          <S.EmailVerifyPopHeadWrap>
            <S.PopBackBtn onClick={closeModal}>Close</S.PopBackBtn>
          </S.EmailVerifyPopHeadWrap>
        )}
        {heading && <p className="heading">{heading}</p>}
        {subHeading && <p>{subHeading}</p>}
        {formFields && (
          <form
            onSubmit={
              updateFormFiledsDataOnLogin ? handleSubmit(onSubmitOnLogin) : handleSubmit(onSubmit)
            }
          >
            {formFields?.length &&
              formFields.map((item, idx) => {
                return (
                  item?.length &&
                  item.map((row, index) => {
                    return (
                      <>
                        {row?.component === 'BUTTON' ? (
                          <button
                            type="button"
                            onClick={e =>
                              row?.type === 'OPEN_MODAL' ? openModal(row) : clickHandler(row)
                            }
                            className="rightAlignButton"
                          >
                            {row?.label}
                          </button>
                        ) : row?.type === 'text' ? (
                          <UserInputs
                            key={index}
                            type={row?.type}
                            inputField={row}
                            register={register(`${row?.name}`, row?.register?.required)}
                            value={row?.value}
                            defaultValue={row?.value}
                            classes={row?.classes?.custom_class}
                            label={row?.label}
                            isEditable={row?.isEditable}
                          />
                        ) : (
                          <Controller
                            control={control}
                            name={row?.name}
                            render={({field: {onChange, onBlur, value, ref}}) => (
                              <UserInputs
                                key={index}
                                type={row?.type}
                                inputField={row}
                                defaultValue={row?.value}
                                onChange={onChange}
                                classes={row?.classes?.custom_class}
                                value={value}
                                {...row}
                              />
                            )}
                          />
                        )}
                      </>
                    );
                  })
                );
              })}
            {errorMessages?.formSubmissionError && (
              <S.ErrorText>{errorMessages?.formSubmissionError}</S.ErrorText>
            )}
            <div className="formSubmitSection">
              {is_closable && (
                <button onClick={closeModal} className="cancelButton" type="button">
                  Cancel
                </button>
              )}
              {submitButton && (
                <button disabled={loader} className="submitButton" type="submit">
                  {submitButton?.label}
                </button>
              )}
            </div>
          </form>
        )}
      </div>
    </S.Container>
  );
};

export default UpdateDetailsForm;
